module.exports = __webpack_public_path__ + "img/about.1432ede5.jpg";